// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"439":"7deab2e0","668":"5c406d55","967":"eb2c06b8"}[chunkId] + ".chunk.css";
};